/** @type {Set<() => void | Promise<void>>} */
const flushers = new Set();

/** Enregistre un flush (debounce + sync immédiate) pour un éditeur Tiptap Puck. */
export function registerPuckRichTextFlusher(flush) {
  flushers.add(flush);
  return () => flushers.delete(flush);
}

/** Flush tous les éditeurs riche avant sauvegarde / changement de page. */
export async function flushAllPuckRichTextEditors() {
  await Promise.all(
    [...flushers].map(async (flush) => {
      try {
        await flush();
      } catch {
        /* noop */
      }
    }),
  );
}
